var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isBasicInfoLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isBasicInfoLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [(_vm.editBasicDetailsflag == false && _vm.uploadcsv == false) ? _c('span', [_vm._v("Create Requested Pickup")]) : (_vm.editBasicDetailsflag == true && _vm.uploadcsv == false) ? _c('span', [_vm._v("Update Requested Pickup")]) : _c('span', [_vm._v("Upload Requested Pickup")])]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('div', [_c('a', {
    attrs: {
      "title": "Back to Requested Pickup List"
    },
    on: {
      "click": _vm.showRequestedPickuplist
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size: 18px"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-header-tab display-flex-space"
  }, [_c('div', _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key;
          _vm.uploadcsv = false
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.value) + "\n            "), (tab.value == 'Create pickup Request') ? _c('span', {
      attrs: {
        "id": "first"
      }
    }, [_c('i', {
      staticClass: "fa fa-info"
    })]) : _vm._e()])
  })), _vm._v(" "), _c('div', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedEditRowData.action != 'edit'),
      expression: "selectedEditRowData.action !='edit'"
    }],
    staticClass: "-btn btn-success",
    staticStyle: {
      "margin-left": "5px",
      "border-radius": "5px 5px 5px 5px"
    },
    attrs: {
      "type": "button",
      "title": "Data Upload"
    },
    on: {
      "click": _vm.UploadData
    }
  }, [_vm._v(" Upload Pickup Request   "), _c('i', {
    staticClass: "fa fa-upload"
  })])])]), _vm._v(" "), (_vm.uploadcsv == false) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v(" Serviceability")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Client Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.companyNamelist,
      "clearable": false,
      "name": "companyName",
      "placeholder": "Select Client Name",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true,
      "hide-selected": true,
      "disabled": _vm.disabledflag == true || (_vm.PickupPincodeServicable == 1 && _vm.DestinationPincodeServicable == 1)
    },
    on: {
      "select": _vm.selectedClient
    },
    model: {
      value: (_vm.clientName),
      callback: function($$v) {
        _vm.clientName = $$v
      },
      expression: "clientName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Pickup PinCode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thumb-tack' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupPinCode),
      expression: "pickupPinCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "pickupPinCode",
      "id": "pickupPinCode",
      "placeholder": "Enter Pincode",
      "disabled": _vm.editPincode == true,
      "pattern": "^(\\d{6})$",
      "maxlength": 6
    },
    domProps: {
      "value": (_vm.pickupPinCode)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupPinCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PickupPincodeServicable == 1),
      expression: "PickupPincodeServicable==1"
    }],
    staticClass: "text-success successmsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Serviceable")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PickupPincodeServicable == 0),
      expression: "PickupPincodeServicable==0"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.sourcepincodeerrmsg))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Destination PinCode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-thumb-tack' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.destinationPinCode),
      expression: "destinationPinCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "destinationPinCode",
      "id": "destinationPinCode",
      "placeholder": "Enter Pincode",
      "disabled": _vm.editPincode == true,
      "pattern": "^(\\d{6})$",
      "maxlength": 6
    },
    domProps: {
      "value": (_vm.destinationPinCode)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.destinationPinCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.DestinationPincodeServicable == 1),
      expression: "DestinationPincodeServicable==1"
    }],
    staticClass: "text-success successmsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Serviceable")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.DestinationPincodeServicable == 0),
      expression: "DestinationPincodeServicable==0"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.destinationpincodeerrmsg))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Select Service")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RouteMode),
      expression: "RouteMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Surface",
      "value": "Surface",
      "name": "RouteMode",
      "disabled": _vm.disabledflag == true || (_vm.PickupPincodeServicable == 1 && _vm.DestinationPincodeServicable == 1)
    },
    domProps: {
      "checked": _vm._q(_vm.RouteMode, "Surface")
    },
    on: {
      "__c": function($event) {
        _vm.RouteMode = "Surface"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Surface"
    }
  }, [_vm._v("Surface ")]), _vm._v("     \n                      \n                        "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RouteMode),
      expression: "RouteMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Air",
      "value": "Air",
      "name": "RouteMode",
      "disabled": _vm.disabledflag == true || (_vm.PickupPincodeServicable == 1 && _vm.DestinationPincodeServicable == 1)
    },
    domProps: {
      "checked": _vm._q(_vm.RouteMode, "Air")
    },
    on: {
      "__c": function($event) {
        _vm.RouteMode = "Air"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Air"
    }
  }, [_vm._v("Air")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Booking Mode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BookingMode),
      expression: "BookingMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "Credit",
      "value": "Credit",
      "name": "BookingMode",
      "disabled": _vm.disabledflag == true || (_vm.PickupPincodeServicable == 1 && _vm.DestinationPincodeServicable == 1)
    },
    domProps: {
      "checked": _vm._q(_vm.BookingMode, "Credit")
    },
    on: {
      "__c": function($event) {
        _vm.BookingMode = "Credit"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Credit"
    }
  }, [_vm._v("Credit ")]), _vm._v("     \n\t\t\t\t\t\t\n\t\t\t\t\t\t  "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.BookingMode),
      expression: "BookingMode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "ToPay",
      "value": "To Pay",
      "name": "BookingMode",
      "disabled": _vm.disabledflag == true || (_vm.PickupPincodeServicable == 1 && _vm.DestinationPincodeServicable == 1)
    },
    domProps: {
      "checked": _vm._q(_vm.BookingMode, "To Pay")
    },
    on: {
      "change": _vm.checkbookingmode,
      "__c": function($event) {
        _vm.BookingMode = "To Pay"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "ToPay"
    }
  }, [_vm._v("FTC")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-warning",
    staticStyle: {
      "color": "white",
      "background-color": "#ff9800"
    },
    attrs: {
      "type": "button",
      "title": "Check Serviceability",
      "disabled": (_vm.pincodeservicabilitycheckflag) || _vm.disabledflag == true
    },
    on: {
      "click": _vm.checkPincodeServicability
    }
  }, [_vm._v("\n                      Check Serviceability\n                      "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pincodeservicabilitycheckflag == true),
      expression: "pincodeservicabilitycheckflag == true"
    }],
    staticClass: "fa fa-check"
  })]), _vm._v("  \n                    "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button",
      "title": "Reset",
      "disabled": _vm.disabledflag == true
    },
    on: {
      "click": _vm.resetPincode
    }
  }, [_vm._v("\n                      Reset "), _c('i', {
    staticClass: "fa fa-refresh"
  })])])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v(" Pickup Details")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Pickup Date")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-calendar-o'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.RequestedPickupDate),
      expression: "RequestedPickupDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "deliverydate",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "date",
      "disabled": _vm.updateflag == true,
      "name": "RequestedPickupDate",
      "onkeydown": "return false",
      "min": _vm.todaysDate,
      "max": _vm.maxDate
    },
    domProps: {
      "value": (_vm.RequestedPickupDate)
    },
    on: {
      "change": function($event) {
        _vm.pickupDateselected()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.RequestedPickupDate = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.PRCutoffcheck) ? _c('span', {
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Requested Pickup cut off time is " + _vm._s(_vm.prcutofftimestr) + ".")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Pickup Instruction(Optional)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupInstruction),
      expression: "pickupInstruction"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "pickupInstruction",
      "name": "pickupInstruction",
      "placeholder": "Enter Pickup Instructions ",
      "maxlength": "250",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.pickupInstruction)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupInstruction = $event.target.value
      }
    }
  })])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "pickuplocationform"
    }
  }, [_c('legend', [_vm._v(" Origin")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AddNewLocationFlag == false),
      expression: "AddNewLocationFlag==false"
    }],
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Select a Location")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.AddNewLocationFlag == false ? 'required' : ''))),
      expression: "`${AddNewLocationFlag == false ? 'required' : ''}`"
    }],
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.Locationlist,
      "placeholder": "Select Location",
      "append-to-body": true,
      "valueFormat": "object",
      "name": "Location",
      "disabled": _vm.disabledflag == true
    },
    on: {
      "input": _vm.selectedLocation
    },
    model: {
      value: (_vm.Location),
      callback: function($$v) {
        _vm.Location = $$v
      },
      expression: "Location"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Location')),
      expression: "errors.has('pickuplocationform.Location')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("The Location field is required")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AddNewLocationFlag == true),
      expression: "AddNewLocationFlag==true"
    }],
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Location Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.LocationName),
      expression: "LocationName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.AddNewLocationFlag == true ? 'required' : ''))),
      expression: "`${AddNewLocationFlag == true ? 'required' : ''}`"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "tabindex": "13",
      "type": "text",
      "name": "LocationName",
      "id": "LocationName",
      "placeholder": "Enter Location Name",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.LocationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.LocationName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.LocationName')),
      expression: "errors.has('pickuplocationform.LocationName')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("The Location Name field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "tabindex": "13",
      "type": "button",
      "title": "Add New Location",
      "disabled": _vm.editLocation == false
    },
    on: {
      "click": _vm.addNewLocation
    }
  }, [_vm._v("Add New Location "), _c('i', {
    staticClass: "fa fa-map-marker"
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Contact Person/Firm Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-marker' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactpersonfirmname),
      expression: "contactpersonfirmname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "tabindex": "14",
      "type": "text",
      "name": "contactpersonfirmname",
      "id": "contactpersonfirmname",
      "placeholder": "Enter your or company name",
      "maxlength": "100",
      "disabled": _vm.AddNewLocationFlag == false || _vm.editBasicDetailsflag
    },
    domProps: {
      "value": (_vm.contactpersonfirmname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactpersonfirmname = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.contactpersonfirmname')),
      expression: "errors.has('pickuplocationform.contactpersonfirmname')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Contact Person/Firm Name is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Mobile")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-mobile' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Mobile),
      expression: "Mobile"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric|digits:10'),
      expression: "'required|numeric|digits:10'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Mobile",
      "id": "Mobile",
      "placeholder": "Enter Mobile Number",
      "maxlength": "10",
      "pattern": "^[6789]\\d{9}$",
      "disabled": _vm.AddNewLocationFlag == false || _vm.editBasicDetailsflag
    },
    domProps: {
      "value": (_vm.Mobile)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Mobile = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Mobile')),
      expression: "errors.has('pickuplocationform.Mobile')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Mobile')))]), _vm._v(" "), (_vm.errors.first('pickuplocationform.Mobile') == 'The Mobile field format is invalid') ? _c('span', {
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("Number Should Start with 6,7,8 or 9")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Email")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-envelope' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Email),
      expression: "Email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Email",
      "id": "Email",
      "placeholder": "Enter Email",
      "disabled": _vm.AddNewLocationFlag == false || _vm.editBasicDetailsflag
    },
    domProps: {
      "value": (_vm.Email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Email')),
      expression: "errors.has('pickuplocationform.Email')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Email')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Alternate Contact Number")]), _c('span', {
    staticClass: "text-danger"
  }), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-phone' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('numeric'),
      expression: "'numeric'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "Telephone",
      "id": "Telephone",
      "placeholder": "Enter Alternate Number",
      "maxlength": "12",
      "minlength": "6",
      "disabled": (_vm.AddNewLocationFlag == false) || _vm.editBasicDetailsflag
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.Telephone')),
      expression: "errors.has('pickuplocationform.Telephone')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.Telephone')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("City")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-pin' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.City),
      expression: "City"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "City",
      "id": "City",
      "placeholder": "Enter City Name",
      "disabled": _vm.editCityFlag == false
    },
    domProps: {
      "value": (_vm.City)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.City = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("GST No "), _c('span', {
    staticClass: "text-danger"
  })]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file-text' style='font-size: 12px'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GstNo),
      expression: "GstNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('validate_gst'),
      expression: "'validate_gst'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "GstNo",
      "id": "GstNo",
      "placeholder": "Enter GST NO. ",
      "disabled": _vm.AddNewLocationFlag == false || _vm.editBasicDetailsflag
    },
    domProps: {
      "value": (_vm.GstNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.GstNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.GstNo')),
      expression: "errors.has('pickuplocationform.GstNo')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.GstNo')))]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "gstBlock"
    }
  }, [_vm._v("Note: Allowed GST Format 00XXXXX0000X1ZZ.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Pickup Address")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pickupAddress),
      expression: "pickupAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "pickupAddress",
      "name": "pickupAddress",
      "placeholder": "Enter Pickup Address",
      "maxlength": "250",
      "disabled": _vm.AddNewLocationFlag == false || _vm.editBasicDetailsflag
    },
    domProps: {
      "value": (_vm.pickupAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pickupAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.pickupAddress')),
      expression: "errors.has('pickuplocationform.pickupAddress')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.pickupAddress')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', [_vm._v(" Shipment Details")]), _vm._v(" "), _c('div', {
    staticClass: "box1 box1_shipmentdetails"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Shipment Weight")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentweight),
      expression: "shipmentweight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "Shipment Weight",
      "id": "shipmentweight",
      "placeholder": "KG",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.shipmentweight)
    },
    on: {
      "keyup": function($event) {
        _vm.isCheckShipment($event, 'shipmentweight')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentweight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pickuplocationform.shipmentweight')),
      expression: "errors.has('pickuplocationform.shipmentweight')"
    }],
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('pickuplocationform.shipmentweight')))]), _vm._v(" "), (_vm.thresholdErr) ? _c('span', {
    staticClass: "text-danger errormsg",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("The Shipment Weight field must be " + _vm._s(_vm.PRwtThreshold) + " or less.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("No.of Boxes")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.noOfBoxes),
      expression: "noOfBoxes"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "noOfBoxes",
      "id": "noOfBoxes",
      "placeholder": "Enter No.of boxes",
      "maxlength": "5",
      "disabled": _vm.updateflag == true
    },
    domProps: {
      "value": (_vm.noOfBoxes)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnlty($event)
      },
      "keyup": function($event) {
        _vm.isCheckShipment($event, 'noOfBoxes')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.noOfBoxes = $event.target.value
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "margin-top": "1rem",
      "margin-left": "22rem"
    }
  }, [_c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.updateflag == true
    },
    on: {
      "click": _vm.validateSaverequest
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Submit")]), _vm._v("   \n                  ")])], 1)])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.uploadcsv == true) ? _c('div', {
    staticClass: "row"
  }, [_c('PickuprequestCSV')], 1) : _vm._e()], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25d382f8","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/requestedpickupgeneration/createrequestedpickup/createrequestedpickup.component.html
// module id = 1940
// module chunks = 3